import { render, staticRenderFns } from "./ServerClock.vue?vue&type=template&id=624bd188&"
import script from "./ServerClock.vue?vue&type=script&lang=js&"
export * from "./ServerClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports